export default "__VITE_ASSET__Db45i3E1__"